export default {
  'settlements.table.column.id': 'Settlement ID',
  'settlements.table.column.partnerId': 'Partner ID',
  'settlements.table.column.partnerName': 'Name',
  'settlements.table.column.startDate': 'Settlement start date',
  'settlements.table.column.endDate': 'end date',
  'settlements.table.column.processedDate': 'Settlement processed date',
  'settlements.table.column.companyId': 'Merchant Id',
  'settlements.table.column.companyName': 'Company name',
  'settlements.table.column.amount': 'Total amount',
  'settlements.table.column.status': 'Status',
  'settlements.sectionFilter.merchant': 'Merchant',
  'settlements.sectionFilter.merchantName': 'Merchant Name',
  'settlements.sectionFilter.settlementEndDateRange':
    'Settlement end date range',
  'settlements.sectionFilter.settlementEndDateRange.from': 'From',
  'settlements.sectionFilter.settlementEndDateRange.to': 'To',
  'settlements.sectionFilter.exportSummary': 'Export summary to Excel',
  'settlements.sectionFilter.exportDetails': 'Export details to Excel',
  'settlements.merchant.sectionTitle': 'Merchant Settlements',
  'settlements.merchant.menuTitle': 'Merchant Settlements',
  'settlements.merchant.title': 'Merchant Settlements',
  'settlements.partner.sectionTitle': 'Partner Settlements',
  'settlements.partner.menuTitle': 'Partner Settlements',
  'settlements.partner.title': 'Partner Settlements',
  'settlements.tab.all': 'All',
  'settlements.tab.pending': 'Pending',
  'settlements.tab.underReview': 'Under Review',
  'settlements.tab.processed': 'Processed',
  'settlements.proofOfPayment.title': 'Payment Proof',
  'settlements.proofOfPayment.totalAmount': 'Total Amount',
  'settlements.proofOfPayment.downloadProof': 'Download Proof',
  'settlements.proofOfPayment.noRelatedSettlements': 'No related settlements found',
  'settlements.proofOfPayment.relatedSettlements': 'Related Settlements',
};
